module.exports = __webpack_public_path__ + "static/media/andrew.74eaaac8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/client/components/About/andrew.jpg
// module id = 230
// module chunks = 2